import React from "react";
import { Pagination } from "zina-dogi-react";
import { Link } from "react-router-dom";
import { utils } from "~/utils";
import { service as activityService } from "../redux";
import { Button } from "zina-dogi-react";
import swal from "sweetalert";

const titles = ["Activity Name", "Smp Name", "Customer Team", "Is Active", "Updated At"];

const ActivityTable = ({ list, pagination, filters, ...props }) => {
    const { className } = props;
    const voaTable_op = {
        className: ["activity_table", className].join(" ")
    };
    return (
        <div {...voaTable_op}>
            <nav className="navbar">
                <span className="navbar-brand h4" />
                <div className="voa_links controls">
                    <Button
                        color="primary"
                        className="ml-1 mr-1"
                        onClick={() => {
                            activityService.requestReport(filters).then(data => {
                                if (data && data.detail) {
                                    swal({
                                        title: "Successfully!",
                                        text: data.detail,
                                        icon: "success",
                                        timer: 3000,
                                        button: true
                                    });
                                }
                            });
                        }}
                    >
                        Activity Report
                    </Button>
                    <Link to="/activity/importer/" className="btn-success btn zina-btn ml-1 mr-1">
                        Activity Importer
                    </Link>
                </div>
            </nav>
            <br />
            <div className="content">
                <table className="table table-bordered table-striped">
                    <thead className="thead-dark">
                        <tr>
                            {titles &&
                                titles.map((title, index) => (
                                    <th key={`activity_title_${index}`} scope="col">
                                        {title}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>{computeRows(list, pagination.actualPage)}</tbody>
                </table>
            </div>
            <Pagination {...pagination} />
        </div>
    );
};

const computeRows = (list, page) => {
    const values = Object.values(list);
    if (values.length > 0) {
        return values.map((activity, i) => {
            const activity_id = activity.id || `p${page}_i${i}`
            return (
                <tr key={`activity_${activity_id}`} style={{ textAlign: "center" }}>
                    <td>
                        <Link to={`/activity/detail/${activity.id}/`}>{activity.activity_name}</Link>
                    </td>
                    <td>{activity.smp_name}</td>
                    <td>{activity.customer_team.name}</td>
                    <td>{activity.is_active ? 'Yes' : 'No'}</td>
                    <td>{utils.renderDate(activity.updated_at)}</td>
                </tr>
            );
        });
    } else {
        return (
            <tr>
                <td colSpan={titles.length}>No data found</td>
            </tr>
        );
    }
};

export default ActivityTable;
